import { Type } from '@angular/core';
import {
  filter,
  OperatorFunction,
}               from 'rxjs';

export function ofType<T, S extends T>(type: Type<S>): OperatorFunction<T, S> {
  return filter((value): value is S => value instanceof type);
}
